import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from "../../../config";
import { useNavigate } from 'react-router-dom';

const Income = () => {
  const navigate = useNavigate();
  const [incomes, setIncomes] = useState([]);
  const [showIncomeForm, setShowIncomeForm] = useState(false);
  const [incomeFormData, setIncomeFormData] = useState({
    source: '',
    description: '',
    amount: ''
  });
  const [loading, setLoading] = useState(false);

  const fetchIncomes = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/api/income`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setIncomes(response.data.incomes);
      }
    } catch (error) {
      console.error('Error fetching incomes:', error);
    }
  };

  useEffect(() => {
    fetchIncomes();
  }, []);

  const handleChange = (e) => {
    setIncomeFormData({ ...incomeFormData, [e.target.name]: e.target.value });
  };

  const submitIncome = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(`${API_URL}/api/income`, incomeFormData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) {
        alert(res.data.message);
        setIncomeFormData({ source: '', description: '', amount: '' });
        setShowIncomeForm(false);
        fetchIncomes();
      } else {
        alert(res.data.message);
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Error processing request');
    }
    setLoading(false);
  };

  const deleteIncome = async (id, isManual) => {
    if (!isManual) {
      alert("Cannot delete automated Invoice income from here. Please manage invoices in the Invoices tab.");
      return;
    }

    if (window.confirm("Are you sure you want to delete this manual income entry?")) {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.delete(`${API_URL}/api/income/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          alert(res.data.message);
          fetchIncomes();
        }
      } catch (error) {
        alert('Error deleting income');
      }
    }
  };

  const calculateTotal = () => {
    return incomes.reduce((sum, inc) => sum + Number(inc.amount || 0), 0);
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Income Log</h2>
        <button 
          onClick={() => setShowIncomeForm(!showIncomeForm)}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: showIncomeForm ? '#6c757d' : '#28a745', 
            color: '#fff', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {showIncomeForm ? 'Cancel' : '+ Add Manual Income'}
        </button>
      </div>

      {showIncomeForm && (
        <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '30px', borderLeft: '4px solid #28a745' }}>
          <h4 style={{ marginBottom: '15px' }}>Record Manual Income</h4>
          <form onSubmit={submitIncome} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Source of Income</label>
              <input 
                type="text" 
                name="source" 
                value={incomeFormData.source} 
                onChange={handleChange} 
                required 
                placeholder="e.g. Consulting, Freelance"
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>
            
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Amount</label>
              <input 
                type="number" 
                name="amount" 
                value={incomeFormData.amount} 
                onChange={handleChange} 
                required 
                min="0"
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ gridColumn: 'span 2' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Description (Optional)</label>
              <input 
                type="text" 
                name="description" 
                value={incomeFormData.description} 
                onChange={handleChange} 
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>
            
            <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>
              <button 
                type="submit" 
                disabled={loading}
                style={{ 
                  padding: '10px 20px', 
                  backgroundColor: '#003e6d', 
                  color: '#fff', 
                  border: 'none', 
                  borderRadius: '4px', 
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {loading ? 'Saving...' : 'Save Income'}
              </button>
            </div>
          </form>
        </div>
      )}

      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '40px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '12px' }}>Date</th>
              <th style={{ padding: '12px' }}>Source</th>
              <th style={{ padding: '12px' }}>Description</th>
              <th style={{ padding: '12px' }}>Amount</th>
              <th style={{ padding: '12px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {incomes.length > 0 ? (
              incomes.map(inc => (
                <tr key={inc._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '12px' }}>{new Date(inc.date).toLocaleString()}</td>
                  <td style={{ padding: '12px' }}>
                    {inc.source}
                    {!inc.isManual && <span style={{ marginLeft: '10px', fontSize: '11px', padding: '2px 6px', background: '#e0f7fa', color: '#006064', borderRadius: '4px' }}>Automated</span>}
                  </td>
                  <td style={{ padding: '12px' }}>{inc.description || '-'}</td>
                  <td style={{ padding: '12px', color: '#28a745', fontWeight: 'bold' }}>+₹{inc.amount}</td>
                  <td style={{ padding: '12px', display: 'flex', gap: '10px' }}>
                    {inc.isManual ? (
                      <button 
                        onClick={() => deleteIncome(inc._id, inc.isManual)} 
                        style={{ background: '#dc3545', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Delete
                      </button>
                    ) : (
                      <button 
                        onClick={() => navigate(`/admin/viewInvoice/${inc._id}`)}
                        style={{ background: '#007bff', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        View Invoice
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ padding: '20px', textAlign: 'center' }}>No income recorded yet.</td>
              </tr>
            )}
          </tbody>
        </table>
        {incomes.length > 0 && (
          <div style={{ padding: '20px', borderTop: '2px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0 }}>Total Income:</h3>
            <h3 style={{ margin: 0, color: '#28a745' }}>₹{calculateTotal()}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default Income;
